module.exports = __webpack_public_path__ + "img/img-2.f682dd86.png";